var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0a5 5 0 0 1 5 5.036Q12.245 5 12.5 5a3.5 3.5 0 0 1 .5 6.964V12H3a3 3 0 0 1-.87-5.872A5 5 0 0 1 7 0m1.66 4.328a.897.897 0 0 0-1.357 0L3.982 7.981v.508c0 .55.444.993.992.993h.508l1.5-2.134v4.634h2V7.348l1.5 2.134h.508c.55 0 .992-.444.992-.993v-.508Z"
})));
export default SvgUploadCloud;